import { useSelector } from 'react-redux';

export function useUser() {
	return useSelector((state) => state.access && state.access.user && state.access.user.loggedUserObj);
}

export function useIsAdmin() {
	const user = useUser();
	return user && user.extra && user.extra.admin;
}
export function useIsLimitedAdmin() {
	const user = useUser();
	return user && user.extra && user.extra.limitedAgent;
}
